import { STORE_TYPES } from '../../config/tenantTypes';
import { retailMenu } from './menu';
import { retailRoutes } from './routes';

const RetailModule = {
  key: STORE_TYPES.SMALL_RETAIL,
  defaultPath: '/dashboard',
  menu: retailMenu,
  routes: retailRoutes,
};

export default RetailModule;
